import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IDeltaHedgeOrderFormValues, IDeltaHedgeOrderTableReport } from "../../Interfaces/deltaHedgeOrder";

interface IDeltaHedgeOrderSlice {
  addOrderFormValues: IDeltaHedgeOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
  editOrderRowValues: IDeltaHedgeOrderTableReport | null;
  editFlag: boolean;
}

const initialState: IDeltaHedgeOrderSlice = {
  addOrderFormValues: {} as IDeltaHedgeOrderFormValues,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
  editOrderRowValues: null,
  editFlag: false,
};

const DeltaHedgeOrderSlice = createSlice({
  name: "deltaHedgeOrderSlice",
  initialState,
  reducers: {
    setDeltaHedgeOrderFormValues: (
      store,
      action: PayloadAction<IDeltaHedgeOrderFormValues>
    ) => {
      store.addOrderFormValues = action.payload;
    },
    onDeltaHedgeOrderFormValuesChange: (
      store,
      action: PayloadAction<{
        name: string;
        value: any;
        name2?: string;
        value2?: any;
      }>
    ) => {
      if (action.payload.name2)
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
          [action.payload.name2]: action.payload.value2,
        } as IDeltaHedgeOrderFormValues;
      else
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
        } as IDeltaHedgeOrderFormValues;
    },
    setDeltaHedgeOrderTableFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setDeltaHedgeTradeTableFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
    setDeltaHedgeEditRowValues: (
      store,
      action: PayloadAction<IDeltaHedgeOrderTableReport | null>
    ) => {
      store.editOrderRowValues = action.payload;
    },
    setDeltaHedgeEditFlag: (store, action: PayloadAction<boolean>) => {
      store.editFlag = action.payload;
    },
  },
});

export const {
  setDeltaHedgeOrderFormValues,
  setDeltaHedgeOrderTableFlag,
  setDeltaHedgeTradeTableFlag,
  onDeltaHedgeOrderFormValuesChange,
  setDeltaHedgeEditRowValues,
  setDeltaHedgeEditFlag,
} = DeltaHedgeOrderSlice.actions;
export default DeltaHedgeOrderSlice.reducer;
